import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement
} from '@stripe/react-stripe-js';
import { Link } from 'react-bootstrap/lib/Navbar';

const CheckoutForm = props => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async ev => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    ev.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setLoading(true);
    const { error } = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: 'https://www.boligninja.dk/profile'
      }
    });
    setLoading(false);

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />

      <div className="form-group">
        <div className="col-xs-12">
          <input type="hidden" name="token" />
          {/* <label htmlFor='terms' className='control-label'>{ this.i18n('Confirm conditions') } <abbr title={ this.i18n('Conditions must be confirmed') }>*</abbr></label> */}
          <label
            style={{
              fontWeight: 'normal',
              display: 'block',
              marginBottom: '16px'
            }}
          >
            <input type="checkbox" id="terms" name="terms" required />
            &nbsp;
            {props.i18n('I have read and accept')}{' '}
            <Link to="/info/terms" onClick={props.modalShow}>
              {props.i18n('the subscription and payment terms')}
            </Link>
          </label>
          {props.error ? (
            <div className="payment-errors alert alert-danger" role="alert">
              {props.i18n(props.error)}
            </div>
          ) : null}
          <button
            type="submit"
            className="submit-button btn btn-success btn-block btn-lg"
            disabled={loading}
          >
            {loading ? <i className="fa fa-fw fa-spin fa-spinner" /> : null}
            {`${
              loading
                ? props.i18n('Creating tenant ad...')
                : props.i18n('Create tenant ad')
            } »`}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CheckoutForm;
